import '../styles/exhibition-list.scss';

document.addEventListener('DOMContentLoaded', () => {
    const lists = document.querySelectorAll('[data-exhibition-list]');
    if (!lists.length) {
        return;
    }

    const updaters = [];

    lists.forEach((list) => {
        const items = list.querySelectorAll('[data-exhibition-index]');
        const images = list.querySelectorAll('[data-exhibition-image]');

        const setActive = (index) => {
            images.forEach((img) => {
                const isActive = img.getAttribute('data-exhibition-image') === index;
                img.classList.toggle('is-active', isActive);
            });
        };

        items.forEach((item) => {
            const index = item.getAttribute('data-exhibition-index');

            item.addEventListener('mouseenter', () => {
                setActive(index);
            });

            item.addEventListener('focusin', () => {
                setActive(index);
            });

            item.addEventListener('click', () => {
                setActive(index);
            });

            item.addEventListener('keydown', (event) => {
                if (event.key === ' ') {
                    event.preventDefault();
                    setActive(index);
                } else if (event.key === 'Enter' && !event.target.closest('a')) {
                    event.preventDefault();
                    setActive(index);
                }
            });
        });

        // Smooth continuous scroll expansion and mobile background fade
        const updateCards = () => {
            if (window.innerWidth >= 1025) {
                const hasActive = list.querySelector('[data-exhibition-image].is-active');
                if (!hasActive && images.length > 0) {
                    const firstIndex = images[0].getAttribute('data-exhibition-image');
                    setActive(firstIndex);
                }
                return;
            }

            const viewportHeight = window.innerHeight;
            const listRect = list.getBoundingClientRect();

            // When the exhibition list is out of view, hide active images
            if (listRect.bottom <= 0 || listRect.top >= viewportHeight) {
                images.forEach((img) => img.classList.remove('is-active'));
                return;
            }

            // Target zone: expand smoothly when item enters from bottom towards middle (0.85 -> 0.45)
            const enterPoint = viewportHeight * 0.85;
            const fullPoint = viewportHeight * 0.45;
            let bestIndex = null;
            let minDistance = Infinity;

            const lastItem = items[items.length - 1];
            if (lastItem) {
                const lastRect = lastItem.getBoundingClientRect();
                // When last item has reached its expanded state in the middle (top <= 45% of viewport),
                // pin the media block to absolute bottom so sticky releases and moves naturally with the scroll
                const isPastLast = lastRect.top <= fullPoint;
                list.classList.toggle('is-ended', isPastLast);
            }

            items.forEach((item) => {
                const rect = item.getBoundingClientRect();
                const itemCenterY = rect.top + rect.height / 2;
                const distFromCenter = Math.abs(itemCenterY - viewportHeight / 2);

                // If rect.top is above enterPoint, it starts expanding towards fullPoint
                // When rect.top <= fullPoint (scrolling down), factor is 1 (fully expanded)
                // When rect.top > enterPoint (below screen/just entering), factor is 0 (compact)
                let factor = 0;
                if (rect.top <= fullPoint) {
                    factor = 1;
                } else if (rect.top < enterPoint) {
                    factor = (enterPoint - rect.top) / (enterPoint - fullPoint);
                }

                item.style.setProperty('--expand-progress', Math.max(0, Math.min(1, factor)).toFixed(3));

                // Find active card for background image
                if (distFromCenter < minDistance) {
                    minDistance = distFromCenter;
                    bestIndex = item.getAttribute('data-exhibition-index');
                }
            });

            if (bestIndex !== null) {
                setActive(bestIndex);
            }
        };

        updaters.push(updateCards);
        updateCards();
    });

    let ticking = false;
    const onScrollOrResize = () => {
        if (!ticking) {
            requestAnimationFrame(() => {
                updaters.forEach((update) => update());
                ticking = false;
            });
            ticking = true;
        }
    };

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
});

